import { render, staticRenderFns } from "./PaymentNotification.vue?vue&type=template&id=6cf7b155&"
import script from "./PaymentNotification.vue?vue&type=script&lang=js&"
export * from "./PaymentNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports